import { characters as defaultCharacters } from './defaultCharacterData';
import { addCharacter, getCharacters, addMap, getMaps } from '@/core/api/files/files';
import logger from '@/app/logger';

// TODO: type this — Vuex module context
/* eslint-disable @typescript-eslint/no-explicit-any */
type Ctx = any;
/* eslint-enable @typescript-eslint/no-explicit-any */

interface LibraryState {
    characters: unknown[];
    maps: unknown[];
}

const LibraryStore = {
    namespaced: true,
    state: {
        characters: defaultCharacters,
        maps: [] as unknown[],
    },
    mutations: {
        updateCharacters(state: LibraryState, characters: unknown[]): void {
            state.characters = [...defaultCharacters, ...characters];
        },
        updateMaps(state: LibraryState, maps: unknown[]): void {
            state.maps = maps;
        },
    },
    actions: {
        async addCharacter(_: Ctx, event: Event): Promise<unknown> {
            const target = event as any;
            const files = target && target.target && target.target.files;
            return await addCharacter(files);
        },
        async getCharacters({ commit }: Ctx): Promise<void> {
            commit('updateCharacters', await getCharacters());
        },
        // TODO - Consider refactoring away this duplication in addMap and getMaps
        async addMap({ dispatch }: Ctx, event: Event): Promise<void> {
            const target = event as any;
            const files = target && target.target && target.target.files;
            try {
                await addMap(files);
                dispatch('getMaps');
            } catch (err: unknown) {
                logger.error(err);
            }
        },
        async getMaps({ commit }: Ctx): Promise<void> {
            const result = await getMaps();
            commit('updateMaps', result);
        },
    },
    getters: {
        characters: (state: LibraryState) => {
            return state.characters;
        },
    },
};

export default LibraryStore;
